import React, { PropTypes, Component } from 'react';
import { Input } from 'semantic-ui-react';
import moment from 'moment';

class Timepicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
    };

    this._onChange = this._onChange.bind(this);
    this._onBlur = this._onBlur.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  _onChange(input, value) {
    this.setState({
      value: value.value,
    });
  }

  _onBlur() {
    if (moment(this.state.value, 'HH:mm', true).isValid()) {
      this.props.onChange(this.state.value);
    } else {
      this.props.onChange(undefined);
    }
  }

  render() {
    const { name, disabled, placeholder } = this.props;

    const { value } = this.state;

    return (
      <Input
        type="text"
        name={name}
        onChange={this._onChange}
        onBlur={this._onBlur}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
      />
    );
  }
}

Timepicker.propTypes = {
  identifier: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

Timepicker.defaultProps = {
  className: '',
  disabled: false,
  placeholder: 'HH:MM',
};

export default Timepicker;



// WEBPACK FOOTER //
// ./src/modules/common/components/Timepicker.js